import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { default as Logo } from '@/assets/logos/miliboo-pom-min.svg?react';

export function SplashScreen(): ReactElement {
  const { t } = useTranslation();

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-layout'>
      <div className='flex flex-col items-center space-y-6'>
        <div className='relative'>
          <div className='absolute inset-0 animate-ping rounded-full bg-primary/20' />
          <div className='relative'>
            <Logo className='h-16 w-16 text-primary' />
          </div>
        </div>
        <div className='text-center'>
          <h1 className='font-bold text-2xl text-layout-foreground'>
            {t('Purchase Order Management')}
          </h1>
          <p className='mt-1 text-layout-foreground-secondary text-sm'>
            {t('Loading')}
          </p>
        </div>
        <div className='flex space-x-1'>
          <div className='h-2 w-2 animate-bounce rounded-full bg-primary [animation-delay:-0.3s]' />
          <div className='h-2 w-2 animate-bounce rounded-full bg-primary [animation-delay:-0.15s]' />
          <div className='h-2 w-2 animate-bounce rounded-full bg-primary' />
        </div>
      </div>
    </div>
  );
}
